import { lazy, Suspense } from 'react';
import { Route, Switch, useLocation } from 'wouter';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { SiteStylesProvider } from './components/SiteStylesProvider';

// Lazy load all page components
const HomePage = lazy(() => import('./components/HomePage').then(m => ({ default: m.HomePage })));
const MembersPage = lazy(() => import('./components/MembersPage').then(m => ({ default: m.MembersPage })));
const MemberBioPage = lazy(() => import('./components/MemberBioPage').then(m => ({ default: m.MemberBioPage })));
const PublicationsPage = lazy(() => import('./components/PublicationsPage').then(m => ({ default: m.PublicationsPage })));
const NewsPage = lazy(() => import('./components/NewsPage').then(m => ({ default: m.NewsPage })));
const NewsDetailPage = lazy(() => import('./components/NewsDetailPage').then(m => ({ default: m.NewsDetailPage })));
const ContactPage = lazy(() => import('./components/ContactPage').then(m => ({ default: m.ContactPage })));
const SimpleAdminDashboard = lazy(() => import('./components/SimpleAdminDashboard').then(m => ({ default: m.SimpleAdminDashboard })));
const LoginPage = lazy(() => import('./components/LoginPage').then(m => ({ default: m.LoginPage })));
const SignUpPage = lazy(() => import('./components/SignUpPage').then(m => ({ default: m.SignUpPage })));

import { PageLoader } from './components/ui/PageLoader';

export default function App() {
  const [location] = useLocation();
  const isAdminRoute = location.startsWith('/admin') || location === '/login' || location === '/signup';

  return (
    <SiteStylesProvider>
      <div className="min-h-screen bg-white relative">
        {!isAdminRoute && (
          <div className="absolute top-0 left-0 right-0 z-50">
            <Navigation currentPath={location} />
          </div>
        )}
        
        <main>
          <Suspense fallback={null}>
            <Switch>
              <Route path="/" component={HomePage} />
              <Route path="/members" component={MembersPage} />
              <Route path="/member/:slug" component={MemberBioPage} />
              <Route path="/publications" component={PublicationsPage} />
              <Route path="/news" component={NewsPage} />
              <Route path="/news/:slug" component={NewsDetailPage} />
              <Route path="/contact" component={ContactPage} />
              <Route path="/admin" component={SimpleAdminDashboard} />
              <Route path="/login" component={LoginPage} />
              <Route path="/signup" component={SignUpPage} />
              <Route>
                <div className="max-w-5xl mx-auto px-6 lg:px-12 py-20 text-center">
                  <h1 className="mb-4">404 - Page Not Found</h1>
                  <p className="text-gray-600">The page you're looking for doesn't exist.</p>
                </div>
              </Route>
            </Switch>
            {!isAdminRoute && <Footer />}
          </Suspense>
        </main>

        <Toaster />
      </div>
    </SiteStylesProvider>
  );
}